import FormattedResidenceFilterData from './FormattedResidenceFilterData';
import processFilterSearchResults from './ProcessFilterSearchResults';

const formatAndMergeFilteredData = (
  allDocs,
  params,
  originalFilterData,
  activeCategoryFilter,
  residenceFavorites = {},
  showByFieldName,
  validFloorPlanUuids,
) => {
  const {
    resultAll,
    resultForFloorPlan,
    resultForBedrooms,
    resultForType,
    resultForLocation,
    resultForOccupancy,
    resultForFavoriteResidences,
  } = processFilterSearchResults( allDocs, params, activeCategoryFilter, residenceFavorites );

  const {
    levelOfCare: filteredLevelOfCareAll,
    units,
  } = FormattedResidenceFilterData( resultAll, showByFieldName, validFloorPlanUuids );
  const {
    levelOfCare: filteredLevelOfCareFloorPlan,
  } = FormattedResidenceFilterData( resultForFloorPlan, showByFieldName, validFloorPlanUuids );
  const {
    levelOfCare: filteredLevelOfCareBedrooms,
  } = FormattedResidenceFilterData( resultForBedrooms, showByFieldName, validFloorPlanUuids );
  const {
    levelOfCare: filteredLevelOfCareType,
  } = FormattedResidenceFilterData( resultForType, showByFieldName, validFloorPlanUuids );
  const {
    levelOfCare: filteredLevelOfCareLocation,
  } = FormattedResidenceFilterData( resultForLocation, showByFieldName, validFloorPlanUuids );
  const {
    levelOfCare: filteredLevelOfCareOccupancy,
  } = FormattedResidenceFilterData( resultForOccupancy, showByFieldName, validFloorPlanUuids );
  const {
    levelOfCare: filteredLevelOfCareFavoriteResidences,
  } = FormattedResidenceFilterData( resultForFavoriteResidences, showByFieldName, validFloorPlanUuids );

  // Merge the filtered data with the original filter data.
  // For the multi-select facets (floor_plan, type, location, occupancy)
  // we now always use the self‑free result.
  const mergedLevelOfCare = {};
  Object.keys( originalFilterData ).forEach( ( locKey ) => {
    if ( originalFilterData[locKey] ) {
      mergedLevelOfCare[locKey] = {
        ...originalFilterData[locKey],
        children: {
          floor_plan_category: {
            ...originalFilterData[locKey].children.floor_plan_category,
            children: filteredLevelOfCareType[locKey]?.children?.floor_plan_category?.children
              || filteredLevelOfCareAll[locKey]?.children?.floor_plan_category?.children || {},
          },
          bedroom_data: {
            ...originalFilterData[locKey].children.bedroom_data,
            children: activeCategoryFilter === 'bedroom_data'
              ? filteredLevelOfCareBedrooms[locKey]?.children?.bedroom_data?.children || {}
              : filteredLevelOfCareAll[locKey]?.children?.bedroom_data?.children || {},
          },
          map_building_grouping: {
            ...originalFilterData[locKey].children.map_building_grouping,
            children: filteredLevelOfCareLocation[locKey]?.children?.map_building_grouping?.children
              || filteredLevelOfCareAll[locKey]?.children?.map_building_grouping?.children || {},
          },
          floor_plan: ( () => {
            const filteredChildren = filteredLevelOfCareFloorPlan[locKey]?.children?.floor_plan?.children || {};
            const originalChildren = originalFilterData[locKey]?.children?.floor_plan?.children || {};
            const mergedFloorPlanChildren = {};
            Object.keys( filteredChildren ).forEach( ( fpUuid ) => {
              const filteredChild = filteredChildren[fpUuid];
              const originalChild = originalChildren[fpUuid];
              const keyColor = ( filteredChild.keyColor && filteredChild.keyColor !== '#000000' )
                ? filteredChild.keyColor
                : ( originalChild?.keyColor || filteredChild.keyColor || '#000000' );
              mergedFloorPlanChildren[fpUuid] = { ...filteredChild, keyColor };
            } );
            return {
              ...originalFilterData[locKey].children.floor_plan,
              children: mergedFloorPlanChildren,
            };
          } )(),
          residence_status: {
            ...originalFilterData[locKey].children.residence_status,
            children: filteredLevelOfCareOccupancy[locKey]?.children?.residence_status?.children
              || filteredLevelOfCareAll[locKey]?.children?.residence_status?.children || {},
          },
          level_of_care: {
            ...originalFilterData[locKey].children.level_of_care,
            children: activeCategoryFilter === 'level_of_care'
              ? originalFilterData[locKey].children.level_of_care.children
              : filteredLevelOfCareAll[locKey]?.children?.level_of_care?.children || {},
          },
          favorite_residences: {
            ...originalFilterData[locKey].children.favorite_residences,
            children: filteredLevelOfCareFavoriteResidences[locKey]?.children?.favorite_residences?.children
              || originalFilterData[locKey]?.children?.favorite_residences?.children || {},
          },
        },
      };
    }
  } );

  return {
    units,
    mergedLevelOfCare,
    resultAll,
  };
};

export default formatAndMergeFilteredData;
